import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { putAPI_Update_RatePlans } from '../../../../../../../constants/APIs';
import PropTypes from 'prop-types';
import RatePlansForm from './RatePlansForm';
import Validation from '../../../../../../../components/Validation';
export default function UpdateRatePlansForm({
  id,
  applicableAddOnsWithIdAndName,
  includedAddOnsWithIdAndName,
  applicablePromosWithIdAndName,
}) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);

  const handleSubmit = data => {
    const formmatedData = { ...data, updater: 'admin' };
    delete formmatedData.id;
    delete formmatedData.images;
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_RatePlans}/${id}`,
      data: formmatedData,
    }).then((res) => {
      if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
        && res.data.Messages !== null && res.data.Messages.length > 0) {
        setMsg(res.data.Messages);
        setOpen(true);
      }
      else {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
    });
  };

  return (
    <div>
      <Button
        color="primary"
        size="sm"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        Edit
      </Button>
      {isUpdating && (
        <RatePlansForm
          formLabel="Update the Rate Plan"
          visible={isUpdating}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          id={id}
          submit={handleSubmit}
          applicableAddOnsWithIdAndName={applicableAddOnsWithIdAndName}
          includedAddOnsWithIdAndName={includedAddOnsWithIdAndName}
          applicablePromosWithIdAndName={applicablePromosWithIdAndName}
        />
      )}
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div>
  );
}

UpdateRatePlansForm.propTypes = {
  id: PropTypes.string.isRequired,
  applicableAddOnsWithIdAndName: PropTypes.array.isRequired,
  includedAddOnsWithIdAndName: PropTypes.array.isRequired,
  applicablePromosWithIdAndName: PropTypes.array.isRequired,
};
